import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPhysicalPersonnel, StateStatus } from '@guryou/redux';

const usePhysicalResources = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.provider.physicalPersonnel);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllPhysicalPersonnel());
    }
  }, [dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default usePhysicalResources;
